import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import BugReportsAdmin from '../../components/admin/BugReportsAdmin';

const BugReportsPage = () => {
  return (
    <AdminLayout title="Bug Reports" requireSuperAdmin>
      <BugReportsAdmin />
    </AdminLayout>
  );
};

export default BugReportsPage;
